export default __webpack_public_path__ + "static/media/codecademy.84bfaee2.svg";